import React from 'react';
import { toJS } from 'mobx';
import { observer, inject } from 'mobx-react';
import { Modal, Button, Row, Col } from 'antd';

@inject('ecodeDemoStore')
@observer
class App extends React.Component {
  static defaultProps = {
    prefixClsNow: 'sys-ecode-releaseNamesConfig',
  }
  componentWillUnmount() {
    const { ecodeDemoStore: { setMobxState } } = this.props;
    setMobxState({ releaseConfigVisible: false, detailConfigParams: {} });
  }
  onCancel = () => {
    const { ecodeDemoStore: { setMobxState } } = this.props;
    setMobxState({ releaseConfigVisible: false });
  }
  onSubmit = () => {
    const { ecodeDemoStore: { addMaintainer } } = this.props;
    addMaintainer();
  }
  handleSelectChange = (value) => {
    const { ecodeDemoStore: { setMobxState } } = this.props;
    setMobxState({ currentMainTainer: value, searchUsers: [], fetching: false });
  }
  getConfigs = () => {
    const { ecodeDemoStore: { setMobxState } } = this.props;
    let { ecodeDemoStore: { detail, detailConfigParams } } = this.props;
    detail = toJS(detail);
    detailConfigParams = toJS(detailConfigParams);
    return [
      {
        title: '已发布应用名',
        dataIndex: 'releaseNames',
        key: 'releaseNames',
        width: '10%',
        render: () => {
          const val = detail.releaseNames ? detail.releaseNames : 'releaseNames';
          return (
            <div>
                {val.split(',').map(item=>{
                    return (<div key={item}>{item}</div>)
                })}
            </div>
          )
        }
      }
    ]
  }
  render() {
    const { prefixClsNow, ecodeDemoStore: { releaseConfigVisible } } = this.props;
    const configs = this.getConfigs();
    return (
      <Modal
        title="已发布应用名"
        visible={releaseConfigVisible}
        onCancel={this.onCancel}
        footer={
          [
            (<Button onClick={this.onCancel} key="detailCancel">返回</Button>),
          ]
        }
      >
        {
          configs.map((config) => (
            <Row key={config.key} className={`${prefixClsNow}-form`}>
              <Col span={8} className={`${prefixClsNow}-label`}>{config.title}：</Col>
              <Col span={16} className={`${prefixClsNow}-wrapper`}>{config.render()}</Col>
            </Row>
          ))
        }
      </Modal>
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/sys/ecodeDemo/releaseNamesConfig.js